// @flow
import { Button } from "../common";
import { MiniTicketCard } from "../cards";
import { type Theme, getSize } from "views/resources/theme";
import { useForm } from "react-hook-form";
import Icon, { Icons } from "react-hp-icons";
import React, { useDispatch, useGlobal, useState } from "reactn";
import styled, { type StyledComponent } from "styled-components";
import type { Line, Office, Poll, Ticket } from "types";

interface Props {
	office: Office;
	ticket: Ticket;
	line: Line;
	onSubmit(Poll): void;
	onClose(): void;
}

const PollPopup = ({ ticket, office, line, onClose }: Props) => {
	const [rating, setRating] = useState<number>(0);
	const [isLoading] = useGlobal("pollIsLoading");
	const [description, setDescription] = useState("");
	const stars = (n: number) => () => setRating(n);
	const submitPoll = useDispatch("submitPollX");
	const onSubmit = () => {
		submitPoll({
			description,
			rating,
			ticket_id: ticket.id,
			office_id: office.id,
		});
	};
	const onChange = ({ target: { value } }) => {
		setDescription(value);
	};
	return (
		<Wrapper>
			{/*
					 <MiniTicketCard ticket={ticket} office={office} line={line} />
				*/}
			<Title>
				¿Cómo estuvo la atención en <span>{office.name}</span>?
			</Title>
			<TicketPoll>
				Ticket{" "}
				<span>
					{ticket.prefix}-{ticket.number}
				</span>
			</TicketPoll>
			<Text>Califica de 1 a 5 estrellas la atención recibida.</Text>
			<Stars>
				<Star filled={rating >= 1} onClick={stars(1)} />
				<Star filled={rating >= 2} onClick={stars(2)} />
				<Star filled={rating >= 3} onClick={stars(3)} />
				<Star filled={rating >= 4} onClick={stars(4)} />
				<Star filled={rating == 5} onClick={stars(5)} />
			</Stars>
			<textarea
				name="message"
				onChange={onChange}
				type="text"
				value={description}
				placeholder="Escribe aquí tu mensaje"
			/>
			<Button
				size="full"
				color="secondary"
				onClick={() => onSubmit()}
				type="button"
				isLoading={isLoading}
			>
				Enviar evaluación
			</Button>
			<A onClick={onClose}>Quizás más tarde</A>
		</Wrapper>
	);
};

interface StarProps {
	filled: boolean;
	onClick(): void;
}
const Star = ({ filled, onClick }: StarProps) => (
	<StarWrapper onClick={onClick}>
		<Icon type={filled ? Icons.star_fill : Icons.star} size={3} />
	</StarWrapper>
);

const Wrapper: StyledComponent<*, Theme, *> = styled.div`
	text-align: center;
	display: flex;
	flex-direction: column;
	padding: ${getSize("m")} ${getSize("l")};

	form {
		display: flex;
		flex-direction: column;
	}

	button {
		margin: 10px 0px;
	}

	textarea {
		font-size: 10px;
		font-weight: 300;
		margin: 10px 0px;
		min-height: 120px;
		padding: ${getSize("m")};
		&::placeholder {
			color: #666;
			font-size: 16px !important;
		}
	}
`;

const StarWrapper = styled.div`
	padding: ${getSize("s")};
	&:hover {
		cursor: pointer;
	}
`;

const TicketPoll = styled.div`
	font-size: 14px;
	margin: 0px;
	span {
		font-weight: 600;
	}
`;

const Text = styled.div`
	font-size: 12px;
	margin: 0px;
	span {
		font-weight: 600;
	}
`;

const Title = styled.div`
	font-size: 14px;
	margin: 15px 0px;
	line-height: 20px;
	span {
		font-weight: 600;
	}
`;

const Stars = styled.div`
	display: flex;
	justify-content: center;
`;

const A = styled.a`
	text-decoration: underline;
	font-size: 9px;
	margin: 10px 0px;
	&:hover {
		cursor: pointer;
	}
`;

export default PollPopup;
